<div class="text-center p-0 md:p-2 max-w-md">
  <div
    class="flex items-center justify-center w-16 h-16 rounded-full mx-auto mb-4"
    [class]="dialogData.iconBg"
  >
    <i
      class="!text-2xl"
      [class]="dialogData.icon + ' ' + dialogData.iconColor"
    ></i>
  </div>

  <h3 class="text-xl font-bold text-gray-900 mb-3">{{ dialogData.heading }}</h3>

  <p class="text-gray-500 leading-relaxed mb-6 text-sm">
    {{ dialogData.message }}
  </p>

  <div class="flex justify-center">
    <p-button
      [label]="dialogData.buttonLabel"
      styleClass="min-w-20"
      (onClick)="onOkClick()"
    />
  </div>
</div>
